import React from 'react';
import {hydrate} from 'react-dom';
import {Provider} from 'react-redux';
import {App} from '../../shared/App';
import {configureStore} from '../../shared/startup/configureStore';
import AbacusClientUtils, {logExperiment} from '@homeaway/abacus-client-utils';
import {TESTS} from '../../shared/utils/abacus';
import buildKnotty from '@homeaway/knotty';

window.ha = window.ha || {};
window.ha.prefix = window.location.pathname.split('/')[1];

if (window.ha.crumb) {
    const knotty = buildKnotty({
        errorRoute: `/${window.ha.prefix}/api/errors`,
        clientLogRoute: `/${window.ha.prefix}/api/cl`,
        token: window.ha.crumb
    });

    window.onerror = knotty.logException;
}

// As we are loading the bundle asynchronously, we should check if the
// DOM is ready before trying to hook into it

function startApp() {
    const readyState = document.readyState;

    /* eslint consistent-return:0 */
    function initReactApp() {
        if (!window.userLocaleData) {
            return setTimeout(initReactApp, 100);
        }

        // Grab the state from a global injected into server-generated HTML
        const preloadedState = window.__PRELOADED_STATE__;

        // Create Redux store with initial state
        const store = configureStore({
            initialState: preloadedState
        });

        const abacus = store.getState().abacus;

        AbacusClientUtils.initialize(abacus);

        if (abacus[TESTS.SLP_AA]) {
            logExperiment(abacus[TESTS.SLP_AA]);
        }

        hydrate(
            <Provider store={store}>
                <App localeData={window.userLocaleData} />
            </Provider>,
            document.querySelector('.app')
        );
    }

    if (readyState === 'interactive' || readyState === 'complete') {
        initReactApp();
    } else {
        document.addEventListener('DOMContentLoaded', initReactApp);
    }

    window.__startApp = null;
}

window.__startApp = startApp;
const polyfilled = window.__polyfilled;

if (polyfilled === true || polyfilled !== false) {
    startApp();
}
